import { render, staticRenderFns } from "./industryDistribution.vue?vue&type=template&id=1e46f42a&scoped=true"
import script from "./industryDistribution.vue?vue&type=script&lang=js"
export * from "./industryDistribution.vue?vue&type=script&lang=js"
import style0 from "./industryDistribution.vue?vue&type=style&index=0&id=1e46f42a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e46f42a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e46f42a')) {
      api.createRecord('1e46f42a', component.options)
    } else {
      api.reload('1e46f42a', component.options)
    }
    module.hot.accept("./industryDistribution.vue?vue&type=template&id=1e46f42a&scoped=true", function () {
      api.rerender('1e46f42a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/industryChainNew/page/industryDistribution.vue"
export default component.exports